import { Breadcrumbs, Chip, Link, Stack } from "@mui/material";
import HerbImage from "../../assets/doors/11_fgbq.jpeg";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { SiteRoutes } from "../../PageRouter";

export const Door11 = () => {
  const ingredients = [
    "Meersalz",
    "Senfkörner",
    "Pastinake",
    "Zitronenschalen",
    "Pfeffer",
    "Knoblauch",
    "Thymian",
    "Fenchel",
    "Rosmarin",
    "Petersilie",
    "Zitronensaftkonzetrat",
  ];

  const doorNr = 11;

  const shortDecription = "Auch die Fische des Königs haben Gräten";

  const herbName = "Lecker für Fisch";

  const recepieExample = (
    <>
      <div>
        <Link href="https://www.chefkoch.de/rezepte/1987231322080893/Ganzer-Fisch-vom-Grill.html">
          Ganzer Fisch vom Grill
        </Link>
      </div>
      <div>
        Ein gehäufter Teelöffel (3g) würzt 250g Fisch. Einfach zum Fisch geben
        und nach Wunsch zubereiten
      </div>
    </>
  );

  const breadcrumb = (
    <Breadcrumbs maxItems={4} separator={<NavigateNextIcon fontSize="small" />}>
      <Link
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        color="inherit"
        href="/"
      >
        Start
      </Link>
      {SiteRoutes.map((route) => {
        if (route.doorNumber && route.doorNumber <= doorNr) {
          return (
            <Link
              key={route.path}
              underline="hover"
              color="inherit"
              href={route.path}
            >
              Tag {route.doorNumber}
            </Link>
          );
        } else {
          return undefined;
        }
      })}
    </Breadcrumbs>
  );

  return (
    <>
      <img src={HerbImage} className="herb_img" alt="herb" />
      {breadcrumb}
      <h1 className="herb_name">{herbName}</h1>
      <i>{shortDecription}</i>
      <h3 className="content">Inhalt</h3>
      <div>
        <Stack
          spacing={1}
          direction="row"
          useFlexGap
          flexWrap="wrap"
          justifyContent="center"
        >
          {ingredients.map((ingredient, i) => {
            return (
              <Chip
                key={i}
                style={{ flexGrow: 1 }}
                label={ingredient}
                variant={i % 2 === 0 ? "filled" : "outlined"}
              />
            );
          })}
        </Stack>
      </div>
      <h3>Rezeptidee</h3>
      {recepieExample}
    </>
  );
};
